import React, { useState, useEffect } from 'react';
import { useAuth } from '../Auth/AuthContext';
import AppMenu from './AppMenu';
import '../css/Dashboard.css';

function Dashboard() {
  const { user, isAuthorized, userRole } = useAuth();
  const [stats, setStats] = useState({ users: 0, posts: 0, comments: 0 });

  useEffect(() => {
    if (isAuthorized) {
      fetchStats();
    }
  }, [isAuthorized]);

  const fetchStats = async () => {
    // ... (keep your existing fetchStats logic)
  };

  const incrementStat = async (statName) => {
    // ... (keep your existing incrementStat logic)
  };

  if (!user) {
    return (
      <div className="container">
        <AppMenu />
        <main className="main">
          <div className="dashboard">
            <p>Please log in to access the dashboard.</p>
          </div>
        </main>
      </div>
    );
  }

  if (!isAuthorized) {
    return (
      <div className="container">
        <AppMenu />
        <main className="main">
          <div className="dashboard">
            <p>You are not authorized to view this dashboard. Your role: {userRole}</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="container">
      <AppMenu />
      <main className="main">
        <div className="dashboard">
          <h2>Admin Dashboard</h2>
          <p>Welcome, {user.displayName} (Role: {userRole})</p>
          <div className="dashboardContent">
            <div className="dashboardItem">
              <h3>Users</h3>
              <p>Total: {stats.users}</p>
              <button onClick={() => incrementStat('users')}>Add User</button>
            </div>
            <div className="dashboardItem">
              <h3>Posts</h3>
              <p>Total: {stats.posts}</p>
              <button onClick={() => incrementStat('posts')}>Add Post</button>
            </div>
            <div className="dashboardItem">
              <h3>Comments</h3>
              <p>Total: {stats.comments}</p>
              <button onClick={() => incrementStat('comments')}>Add Comment</button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Dashboard;